export default {
  props: {
    url: String,
    replace: Boolean,
    goBack: [Boolean, Number],
    to: [String, Object]
  },
  methods: {
    routerLink () {
      const { to, url, $router, replace } = this
      if (this.goBack && $router) {
        if (typeof this.goBack === 'boolean') {
          $router.go(-1)
          return
        } else if (!isNaN(this.goBack) && Number(this.goBack) < 0) {
          $router.go(Number(this.goBack))
          return
        }
      }
      if (to && $router) {
        $router[replace ? 'replace' : 'push'](to)
        // window.location.replace(to)
      } else if (url) {
        replace ? location.replace(url) : location.href = url
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/router-link.js